import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { endpoints } from "../api";

const Dashboard = () => {
  const [data, setData] = useState({ campaigns: [], count: 0 });
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();
  const userEmail = localStorage.getItem('user_email');

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await endpoints.get_campaigns(userEmail);
      setData({
        campaigns: res.data.campaigns || [],
        count: res.data.count || 0
      });
    } catch (e) {
      console.error("Failed to fetch campaigns", e);
    } finally {
      setLoading(false);
    }
  }, [userEmail]);

  useEffect(() => {
  fetchData();
}, [fetchData]);

  const openCampaignDetails = (name) => {
    localStorage.setItem("active_campaign", name);
    navigate('/tracker'); 
  };

  if (loading) {
    return <div style={{ padding: '40px', color: 'white', textAlign: 'center' }}>Loading Campaigns...</div>;
  }

  return (
  <div style={{ 
    // padding: '40px', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    width: '100%',
    // minHeight: '100vh',
    boxSizing: 'border-box'
  }}>
    {/* Main Container to match Layout width */}
    <div style={{ width: '100%', maxWidth: '1200px' }}>
      
      {/* Header Section */}
      <div style={{ marginBottom: '40px', textAlign: 'left' }}>
        <h2 style={{ margin: 0, fontSize: '32px', color: 'white', fontWeight: 'bold' }}>Dashboard</h2>
        <p style={{ color: 'var(--text-dim)', marginTop: '8px', fontSize: '16px' }}>
          You have {data.count} active AI sequences.
        </p>
      </div>

      {/* THE GRID: Explicitly set to prevent any overlapping */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', 
        gap: '30px', 
        width: '100%',
        margin: '0 auto',
        paddingBottom: '50px'
      }}>
        {data.campaigns.map((camp, index) => (
          <div 
            key={index} 
            className="auth-card" 
            onClick={() => openCampaignDetails(camp.campaign_name)}
            style={{ 
              cursor: 'pointer', 
              padding: '30px', 
              border: '1px solid var(--border)',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              minHeight: '260px',
              transition: 'all 0.3s ease',
              background: 'var(--card)',
              margin: '0', /* Essential to prevent stacking */
              boxSizing: 'border-box'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'var(--accent)';
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'var(--border)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {/* Status Badge */}
            <div style={{ 
              position: 'absolute', top: '25px', right: '25px', 
              fontSize: '11px', padding: '5px 12px', borderRadius: '6px', fontWeight: 'bold',
              background: camp.status === 'active' ? 'rgba(34, 197, 94, 0.15)' : 'rgba(234, 179, 8, 0.15)',
              color: camp.status === 'active' ? '#4ade80' : '#facc15',
              border: `1px solid ${camp.status === 'active' ? '#4ade80' : '#facc15'}`,
              textTransform: 'uppercase',
              letterSpacing: '0.8px',
              zIndex: 2
            }}>
              {camp.status}
            </div>

            <div style={{ fontSize: '42px', marginBottom: '20px' }}>🚀</div>
            
            <div style={{ flex: 1 }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '24px', color: 'white', fontWeight: '700' }}>
                {camp.campaign_name}
              </h3>
              
              <div style={{ fontSize: '15px', color: 'var(--text-dim)', lineHeight: '1.8' }}>
                <div style={{ marginBottom: '6px' }}>
                  <strong style={{ color: 'var(--accent)' }}>Goal:</strong> {camp.goal}
                </div>
                <div>
                  <strong style={{ color: 'var(--accent)' }}>Industry:</strong> {camp.industry}
                </div>
              </div>
            </div>

            {/* Bottom Section */}
            <div style={{ 
              marginTop: '25px', 
              paddingTop: '20px', 
              borderTop: '1px solid var(--border)', 
              fontSize: '13px', 
              color: 'var(--text-dim)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span>Created: {new Date(camp.created_at).toLocaleDateString()}</span>
              <span style={{ color: 'var(--accent)', fontWeight: 'bold' }}>View Details →</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
};

export default Dashboard;